<template>
  <div>
    <v-navigation-drawer
      v-if="showNavigationDrawer"
      expand-on-hover
      :mobile-breakpoint="customMobileBreakpoint"
      color="primary"
      app
      clipped
    >
      <v-divider></v-divider>

      <!-- Elementos de menú con enrutamiento -->
      <v-list nav dense v-for="item in routedItems" :key="item.id">
        <router-link :to="item.router" exact>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="red">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="color: red">{{
              item.text
            }}</v-list-item-title>
          </v-list-item>
        </router-link>
      </v-list>

      <!-- Elementos de menú con componentes -->
      <v-list nav dense v-for="item in componentItems" :key="item.id">
        <v-list-item
          link
          @click="loadComponent(item.component), emitEvent(item.text)"
        >
          <v-list-item-icon>
            <v-icon color="white">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title style="color: white">{{
            item.text
          }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <component :is="currentComponent"></component>
  </div>
</template>


<script>
import Operadores from "../relations/FormEdit.vue";
import Empleados from "../relations/Employee.vue";
import Grupos from "../relations/Group.vue";
import UnNegocio from "../relations/BusinessUnits.vue";
import Audit from "../relations/Audit.vue";
export default {
  props: {
    showNavigationDrawer: Boolean,
  },
  data() {
    return {
      customMobileBreakpoint: 300,
      routedItems: [],
      componentItems: [
        {
          text: this.$t("operators.operator"),
          icon: "mdi-account-hard-hat",
          id: 1,
          component: Operadores,
        },
        {
          text: this.$t("operators.employees"),
          icon: "mdi-account-group",
          id: 2,
          component: Empleados,
        },
        {
          text: this.$t("operators.groups"),
          icon: "mdi-group",
          id: 3,
          component: Grupos,
        },
        {
          text: this.$t("operators.business"),
          icon: "mdi-domain",
          id: 5,
          component: UnNegocio,
        },
        {
          text: this.$t("operators.audit"),
          icon: "mdi-file-check",
          id: 6,
          component: Audit,
        },
      ],
      currentComponent: Operadores,
    };
  },
  methods: {
    loadComponent(component) {
      this.currentComponent = component;
    },
    emitEvent(texto) {
      this.$emit("nameItem", texto);
    },
  },
};
</script>